import { inject, injectable } from 'inversify';
import { action, computed, makeObservable } from 'mobx';
import { TYPES } from '@/engine/ioc';
import type { ViewEntity } from './models/viewEntity/view.entity.ts';
import type { ViewsService } from './Views.service';

@injectable()
export class ViewsListController {
  private _viewsService: ViewsService;

  public constructor(@inject(TYPES.ViewsService) viewsService: ViewsService) {
    makeObservable(this);

    this._viewsService = viewsService;
  }

  @computed
  public get views(): Array<ViewEntity> {
    return this._viewsService.views;
  }

  @computed
  public get currentView(): ViewEntity | null {
    return this._viewsService.currentView;
  }

  @action
  public setCurrentView(view: ViewEntity): void {
    this._viewsService.setCurrentView(view);
  }
}
